<h2 mat-dialog-title>{{data.mode}} Mobile Phone Number</h2>


      <ng-container *ngIf="!show_verify_otp">
        <ng-container *ngTemplateOutlet="add_phone_number_template"></ng-container>
      </ng-container>
      <ng-container *ngIf="show_verify_otp">
        <ng-container *ngTemplateOutlet="verify_otp_template"></ng-container>
      </ng-container>




<ng-template #add_phone_number_template>
<mat-dialog-content>
  <form [formGroup]="mobile_form" method="post">
    <div class="row align-items-center mb-3">
      <div class="col-md-6">
        <label class="form-label">Enter Mobile Number</label>
      </div>
        <div class="input-cell col-md-6">
                    <mat-form-field>
                    <input matInput
                 type="text"
                 formControlName="mobile_phone"
                 mask="(000) 000-0000" />
                    </mat-form-field>
                  </div>
    </div>
    <nexus-form-result [model]="mobile_form_result"></nexus-form-result>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close_mobile_phone_dialog()">Cancel</button>
  <button mat-raised-button color="primary"
          [disabled]="mobile_form.invalid" (click)="resend_otp_details()">
    Verify Mobile Number
  </button>
</mat-dialog-actions>
</ng-template>


<ng-template #verify_otp_template>
   <mat-dialog-content>
    <div class="text-center mb-3">Enter the 6-digit code sent to {{masked_user_otp_method}}</div>
    <form [formGroup]="otpForm" class="d-flex gap-2 justify-content-center">
      <div class="col-auto" *ngFor="let key of controls; let i = index">
        <input
          type="text"
          maxlength="1"
          class="form-control text-center otp-input"
          [formControlName]="key.toString()"
          (input)="onInput($event, i)"
          (keydown)="onKeyDown($event, i)"
          (paste)="onPaste($event)"
        />
      </div>
    </form>
    <div class="text-center mb-3 mt-2">Your verification code expires in {{(otp_ttl_seconds / 60) | number:'1.0-0' }} mins</div>
    <div class="text-center">
      <button class="btn btn-link" *ngIf="canResend" (click)="resend_otp_details()">
        Resend your code
      </button>
      <div *ngIf="!canResend" class="text-muted">
        Didn't receive the code? <span class="resend-timer">You can resend it in :{{ timerValue }}s</span>
      </div>
    </div>
    <nexus-form-result [model]="mobile_form_result"></nexus-form-result>
  </mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close_mobile_phone_dialog()">Cancel</button>
  <button mat-raised-button color="primary"
          (click)="verify_mobile_phone_otp()"
          [disabled]="otpForm.invalid">
    Verify your Code
  </button>
</mat-dialog-actions>
</ng-template>

